/** @type {import('./index').NetworkConfig} */
const instagram = {
  name: 'Instagram',
  sort: 2,
  baseUrl: 'https://www.instagram.com/',
  domains: ['instagram.com', 'instagr.am'],
  supported: true,
  color: '#E1306C',
  hasVideoContent: true,
  supportsEmbed: false,
  requiresReferrer: false,
  profileUrlPattern: /^https:\/\/(?:www\.)?instagram\.com\/(?!account(?:\/|$|\/posts|\/media|\/igtv|\/saved|\/tagged)|explore|direct\/(?:inbox|t)|accounts\/activity)([a-zA-Z0-9_.]+)\/?$/,
};

export default instagram;
